var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBurgerMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 30 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 20h10v-3.333H0V20ZM0 0v3.333h30V0H0Zm0 11.667h20V8.333H0v3.334Z"
})));
export default SvgBurgerMenu;